<template>
  <v-app id="inspire">
    <v-main>
      <v-container
        class="fill-height pa-0"
        fluid
        :style="`background-image: url('${backgroundImage}'); background-position: center center; background-size: cover;`"
      >
        <v-col offset-sm="1" sm="10">
          <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="6">
              <v-card v-bind="cardAttrs" class="elevation-12">
                <v-col class="d-flex justify-center pt-12">
                 <v-avatar size="400" max-height="60px" tile>
                    <v-img :src="logoImage" height="100%" contain />
                  </v-avatar>
                </v-col>

                <v-card-title class="d-flex justify-center pt-0">
                  <h5 class="text--disabled font-weight-light">Autenticação</h5>
                </v-card-title>
                <v-card-text>
                  <core-form :submit="login">
                    <v-col>
                      <input-email v-if="loginField === 'email'" label="E-mail" v-model="credentials[loginField]" autofocus placeholder=" " />
                      <input-documento v-if="loginField === 'documento'" label="CPF/CNPJ" v-model="credentials[loginField]" autofocus placeholder=" " />
                      <input-text v-if="loginField === 'username'" label="Usuário" v-model="credentials[loginField]" autofocus placeholder=" " />
                    </v-col>
                    <v-col class="pb-1 pt-2">
                      <input-text
                        label="Senha"
                        :type="showPassword ? 'text' : 'password'"
                        v-model="credentials.password"
                        placeholder=" "
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="showPassword = !showPassword"
                      />
                    </v-col>
                    <v-col class="pt-0 pb-10">
                      <router-link
                        to="/lembrar"
                        class="float-right font-weight-medium caption text-decoration-none"
                        >Esqueceu a senha?</router-link
                      >
                      <v-btn
                        type="submit"
                        :disabled="!credentials[loginField] || !credentials.password"
                        color="primary"
                      >
                        Entrar
                      </v-btn>
                      <v-alert
                        v-show="error"
                        type="error"
                        class="mt-3"
                        text
                        icon="error"
                      >
                        {{ error }}
                      </v-alert>
                    </v-col>
                  </core-form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-container>
      <core-login-error ref="loginError" @follow="followLogin" />
    </v-main>
  </v-app>
</template>

<script>
export default {
  metaInfo: {
    title: 'Login'
  },
  props: {
    logoImage: { type: String, default: require('shared/images/svg/logo-black.svg') },
    backgroundImage: { type: String, default: require('shared/images/svg/background.svg') },
    redirect_url: null,
    loginField: { type: String, default: 'email' },
    cardAttrs: { type: Object, default: () => {} }
  },
  data: () => ({
    credentials: {
    },
    showPassword: false,
    error: ''
  }),
  methods: {
    login () {
      const th = this;
      th.$api.Autenticacao.Autenticar(th.credentials)
        .then(function (data) {
          if (data.errorCode) {
            th.$refs.loginError.openModal(data);
          } else if (th.$api.UI.PostLoadData(data, true)) {
            th.setUser(data)
          }
        })
        .catch((err) => console.log(err));
    },
    followLogin (data) {
      const th = this;
      th.setUser(data);
    },
    setUser (authResponse) {
      const th = this;
      const user = th.$api.UTIL.Auth.RegisterToken(authResponse)
      if (user) {
        th.$store.dispatch('setUserData', { user }).then(() => {
          if (th.redirect_url) { th.$router.push(th.redirect_url) } else { th.$router.goToHome() }
        })
      }
    },
  }
}
</script>
